<template>
  <div>home</div>
</template>

<script>
export default {
  name: "home-page",
};
</script>

<style></style>
